import { Injectable } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OWCC_QUERY_PARAM } from 'src/app/core/config/query-params.config';

import { NbaParamResolver } from '../nba-param-resolver.interface';

import { NbaParamResolverId } from './nba-param-resolver-id.enum';

@Injectable()
export class SalesTouchEnvironmentResolver implements NbaParamResolver {
  public readonly identifier: string = NbaParamResolverId.SalesTouchEnvironment;

  public constructor(private readonly route: ActivatedRoute) {}

  /**
   * @returns resolved sales touch environment (by URL query parameter 'environment')
   */
  public resolve$(): Observable<string> {
    return this.route.queryParamMap.pipe(
      map((params: ParamMap) => params.get(OWCC_QUERY_PARAM.SALES_TOUCH_ENVIRONMENT) || 'PROD')
    );
  }
}
